import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import OurFundationComponent from "salad/OurFundationComponent";
import MobileHeaderOnly from "components/headers/light.js";
import GrainFooter from "salad/GrainFooter";

export default () => (
    <div style={{ backgroundColor: "#FFFBDC" }}>
        <MobileHeaderOnly />
        <AnimationRevealPage>
            <OurFundationComponent />
            <GrainFooter/>
        </AnimationRevealPage>
    </div>
);
